import { getDropdownFilterBattery } from "./getDropdownFilterBattery.js"
import { getDropdownFilterSolar } from "./getDropdownFilterSolar.js"
import { getDropdownFilterLoad } from "./getDropdownFilterLoad.js"
import { getDropdownFilterGrid } from "./getDropdownFilterGrid.js"
import { getDropdownFilterGenerator } from "./getDropdownFilterGenerator.js"
import { getDropdownFilterTank } from "./getDropdownFilterTank.js"
import { getDropdownFilterTemperature } from "./getDropdownFilterTemperature.js"
import { getDropdownFilterLastUpdate } from "./getDropdownFilterLastUpdate.js"
import {
    getTagsToDropdownFilter,
    getAlarmsToDropdownFilter,
    getTeamsToDropdownFilter,
    getGroupsToDropdownFilter
} from "./getDropdownFilterTags.js"

export {
    getDropdownFilterBattery,
    getDropdownFilterSolar,
    getDropdownFilterLoad,
    getDropdownFilterGrid,
    getDropdownFilterGenerator,
    getDropdownFilterTank,
    getDropdownFilterTemperature,
    getDropdownFilterLastUpdate,
    getTagsToDropdownFilter,
    getAlarmsToDropdownFilter,
    getTeamsToDropdownFilter,
    getGroupsToDropdownFilter,
};

export const initializeDropdownFilter = (installationsTags = [], alarmTags = []) => {
    const filters = [
        getDropdownFilterBattery(),
        getDropdownFilterSolar(),
        getDropdownFilterLoad(),
        getDropdownFilterGrid(),
        getDropdownFilterGenerator(),
        getDropdownFilterTank(),
        getDropdownFilterTemperature(),
        getDropdownFilterLastUpdate(),
    ]
    const alarms = getAlarmsToDropdownFilter(alarmTags);
    const teams = getTeamsToDropdownFilter(installationsTags);
    const tags = getTagsToDropdownFilter(installationsTags);
    const groups = getGroupsToDropdownFilter(installationsTags);

    alarms && filters.push(alarms);
    teams && filters.push(teams);
    groups && filters.push(groups);
    tags && filters.push(tags);
    return filters;
};

/*
 * @param dropdownFilter - should be the structure of the return initializeDropdownFilter
 * @return - the values to be used in the overview search
 */

export const transformDropdownValuesToFilters = (dropdownFilter) => {
    let newFilters = {};
    dropdownFilter.forEach(dropdown => {
        let options = {}
        dropdown.options.forEach(option =>{
            if(option.type === "check" || option.type === "tags"){
                options = {
                    ...options,
                    [option.variable]: option.options.filter(o => o.value).map(o => o.variable),
                }
            } else if(option.type === "radio"){
                options = {
                    ...options,
                    [option.variable]: option.selected,
                }
            } else if(option.type === "minMax"){
                options = {
                    ...options,
                    [option.variable]: {
                        min: option.min,
                        max: option.max,
                    }
                }
            }
        })
        newFilters = {
            ...newFilters,
            [dropdown.id]: {
                ...options
            }
        }
    })

    return newFilters;
}
